module.exports = __webpack_public_path__ + "img/ez-theme-switcher-ic-promotion.507a4779.png";